import {
	faChevronLeft,
	faEdit,
	faTrashAlt,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import * as React from "react";
import { useState } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom";
import {
	Button,
	CardLink,
	Modal,
	ModalBody,
	ModalFooter,
	ModalHeader,
	Row,
	Spinner,
} from "reactstrap";
import { Dispatch } from "redux";
import { MusicPlatformAction } from "../../../actions/musicPlatformAction";
import { showAlert } from "../../common/functions";
import MusicPlatformModal from "./musicPlatformDetail";
import { store } from "react-notifications-component";

interface MusicPlatformProps {
	dispatch: Dispatch<any>;
	musicPlatformData: any;
}

const MusicPlatformList: React.SFC<MusicPlatformProps> = ({
	dispatch,
	musicPlatformData,
}) => {
	const history = useHistory();
	const [currentPage, setCurrentPage] = useState<number>(1);
	const [selectedId, setSelectedId] = useState(-1);
	const [editedId, setEditedId] = useState(0);
	const [showModal, setShowModal] = useState(false);
	const [openDetailModal, setOpenDetailModal] = useState(false);
	const [showDeleteModal, setShowDeleteModal] = useState(false);
	const [savePlatform, setSavePlatform] = useState(false);
	const [detailLoading, isUpdateDetailLoading] = useState<boolean>(false);

	React.useEffect(() => {
		const body = {
			pageNumber: 1,
			pageSize: 25,
			isActive: null,
		};
		setShowModal(true);
		dispatch(MusicPlatformAction.musicPlatformGetByFilter(body));
	}, []);

	React.useEffect(() => {
		if (musicPlatformData?.isSuccessSave) {
			const body = {
				pageNumber: 1,
				pageSize: 25,
				isActive: null,
			};
			setShowModal(true);
			dispatch(MusicPlatformAction.musicPlatformGetByFilter(body));
			const alertMessage = musicPlatformData?.status;
			if (alertMessage && alertMessage != "") {
				store.addNotification({
					title: "Success!",
					message: alertMessage,
					type: "success",
					insert: "top",
					container: "top-right",
					animationIn: ["animate__animated", "animate__fadeIn"],
					animationOut: ["animate__animated", "animate__fadeOut"],
					dismiss: {
						duration: 5000,
						onScreen: true,
					},
				});
				window.localStorage.setItem("alertMessage", "");
			}
			musicPlatformData.isSuccessSave = false;
			musicPlatformData.status = '';
		}
	}, [musicPlatformData?.isSuccessSave]);

	const handleCloseClick = () => {
		setShowDeleteModal(false);
	};

	const handleLoadDeleteModal = () => {
		dispatch(MusicPlatformAction.musicPlatformDelete(selectedId));
		setShowModal(true);
		setShowDeleteModal(false);
	};

	const toggleDetailModal = () => {
		// setOpenDetailModal((prev) => !prev);
		setOpenDetailModal(false)
		setEditedId(0);
	};

	if (
		musicPlatformData &&
		!musicPlatformData.isLoading &&
		musicPlatformData.isListSuccess
	) {
		musicPlatformData.isListSuccess = false;
		if (showModal) {
			setShowModal(false);
		}
	}

	if (
		selectedId >= 0 &&
		musicPlatformData.isSuccess &&
		(musicPlatformData.isDeleteCompleted) &&
		!musicPlatformData.isError
	) {
		showAlert(musicPlatformData.status, false);
		musicPlatformData.isSuccess = false;
		musicPlatformData.isDeleteCompleted = false;
		const body = {
			id: 0,
		};
		setShowModal(true);
		dispatch(MusicPlatformAction.musicPlatformGetByFilter(body));
		setCurrentPage(
			musicPlatformData?.items?.streamingPlatforms?.length === 1
				? currentPage - 1
				: currentPage
		);
		setSelectedId(-1);
	}
	if (!musicPlatformData.isSuccess && musicPlatformData.isError) {
		if (musicPlatformData.status === "Unauthorized") {
			history.push("/401");
		} else {
			showAlert(musicPlatformData.status, true);
		}
		musicPlatformData.isError = false;
		isUpdateDetailLoading(!detailLoading);
		setSelectedId(-1);
		if (showModal) {
			setShowModal(false);
		}
	}

	const handleSelectForDelete = (id: any) => {
		setSelectedId(id);
		setShowDeleteModal(true);
	};

	return (
		<div data-testid="musicPlatformPage" className="musicPlatform-list">
			<div className="card-box">
				<div className="card-box-link-back-div">
					<FontAwesomeIcon icon={faChevronLeft} />
					<CardLink
						onClick={() => history.push("/music")}
						className="card-box-link-back"
						data-testid="bible-backtolist"
					>
						Back to Music
					</CardLink>
				</div>
				<Row className="filter-link-container justify-content-end">
					<Button
						id="submit"
						data-testid="createNewmusicPlatform"
						className="btn-submit-frm"
						onClick={() => setOpenDetailModal(true)}
					>
						Create New
					</Button>
				</Row>
			</div>

			<div className="musicPlatform-table">
				<table className="table table-hover" data-testid="musicPlatformTable">
					<thead data-testid="musicPlatformTableHead">
						<tr>
							<th scope="col" data-testid="detail-th">
								Details
							</th>
							<th scope="col" data-testid="platformname-th">
								Platform Name
							</th>
							<th scope="col" data-testid="logo-th">
								Platform Logo
							</th>
							<th scope="col" data-testid="delete-th">
								Delete
							</th>
						</tr>
					</thead>
					<tbody data-testid="musicPlatformTableBody">
						{showModal ? (
							<tr>
								<td colSpan={5} className="text-center">
									<Spinner />
								</td>
							</tr>
						) : (
							<>
								{musicPlatformData &&
								musicPlatformData?.items?.streamingPlatforms?.length > 0 ? (
									musicPlatformData?.items?.streamingPlatforms?.map(
										(data: any) => (
											<>
												<tr key={data.platformId}>
													<th scope="row" className="icon-column" data-testid="musicPlatformDetailButton">
														<FontAwesomeIcon
															size="2x"
															icon={faEdit}
															title="Details"
															cursor="pointer"
															className="detailButton"
															onClick={() => {
																setOpenDetailModal(true);
																setEditedId(data?.platformId);
															}}
														/>
													</th>
													<td id="platformName">{data?.platformName} </td>
													<td id="platformLogo" className="icon-column">
														<img
															src={data?.platformLogoUrl}
															width={40}
															alt="logo"
														/>
													</td>
													<td className="icon-column">
														<FontAwesomeIcon
															size="2x"
															icon={faTrashAlt}
															data-testid="musicPlatformDeleteButton"
															data-bs-toggle="tooltip"
															cursor="pointer"
															data-bs-placement="bottom"
															title="Delete"
															onClick={() =>
																handleSelectForDelete(data?.platformId)
															}
														/>
													</td>
												</tr>
											</>
										)
									)
								) : (
									<tr>
										<td colSpan={5} className="text-center h6">
											No Data found.
										</td>
									</tr>
								)}
							</>
						)}
					</tbody>
				</table>
			</div>
			<Modal
				isOpen={showDeleteModal}
				backdrop="static"
				centered
				data-testid="deleteModal"
			>
				<ModalHeader>Delete Music Platform</ModalHeader>
				<ModalBody className="modal-body">
					<form name="deleteTestimoForm">
						<div
							className="col-form-label"
							data-testid="musicPlatformDeleteMessage"
						>
							Deleting this Music Platform will permanently remove. To confirm,
							please click Confirm Delete.
						</div>
					</form>
				</ModalBody>
				<ModalFooter>
					<Button
						type="button"
						color="secondary"
						data-bs-dismiss="modal"
						onClick={handleCloseClick}
						data-testid="cancelDeleteButton"
					>
						Cancel
					</Button>
					<Button
						type="button"
						color="primary"
						onClick={handleLoadDeleteModal}
						data-testid="confirmDeleteButton"
					>
						Confirm Delete
					</Button>
				</ModalFooter>
			</Modal>
			<MusicPlatformModal
				isOpen={openDetailModal}
				toggleDetailModal={toggleDetailModal}
				id={editedId}
				dispatch={dispatch}
				musicPlatformData={musicPlatformData}
				detailLoading={detailLoading}
			/>
		</div>
	);
};

const mapStateToProps = (state: any) => {
	const { musicPlatformData, languageData } = state;
	return {
		musicPlatformData,
		languageData,
	};
};

export default connect(mapStateToProps)(MusicPlatformList);
